import { render, staticRenderFns } from "./SolicitarAutorizacao.vue?vue&type=template&id=554b62b6"
import script from "./SolicitarAutorizacao.vue?vue&type=script&lang=js"
export * from "./SolicitarAutorizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports